"use strict";

(function () {
  function locationIdKey(id) {
    if (id == null) return "";
    const s = String(id);
    const parts = s.split("/");
    return parts[parts.length - 1] || s;
  }

  function readSelectedLocation() {
    try {
      const raw = window.localStorage.getItem("selected-location");
      if (!raw) return null;
      return JSON.parse(raw);
    } catch {
      return null;
    }
  }

  function storeDisplayLabel(location) {
    const address = location?.address || {};
    const city = String(address.city || "").trim();
    const region = String(address.provinceCode || address.province || "").trim();
    const line = [city, region].filter(Boolean).join(", ").trim();
    return line || String(location?.name || "").trim();
  }

  class ProductShippingBopis extends HTMLElement {
    connectedCallback() {
      this._script = this.querySelector("[data-shipping-bopis-variants]");
      this._variants = {};
      if (this._script?.textContent) {
        try {
          this._variants = JSON.parse(this._script.textContent);
        } catch {
          this._variants = {};
        }
      }

      this._shipDateEl = this.querySelector("[data-ship-date]");
      this._shipLabelEl = this.querySelector("[data-ship-label]");
      this._pickupLineEl = this.querySelector("[data-pickup-line]");
      this._pickupHeadingEl = this.querySelector("[data-pickup-heading]");
      this._linkEl = this.querySelector("[data-open-store-selector]");

      this._root =
        this.closest("article.m6pr") || document.getElementById("main-product");

      this._onStorage = (e) => {
        if (e.key === "selected-location" || e.key === null) {
          this.refreshFromDom();
          if (
            typeof window.storeSelectorSyncPreferredPickupFromStorage ===
            "function"
          )
            window.storeSelectorSyncPreferredPickupFromStorage();
        }
      };
      this._onStoreSelected = () => {
        this.refreshFromDom();
        if (
          typeof window.storeSelectorSyncPreferredPickupFromStorage ===
          "function"
        )
          void window.storeSelectorSyncPreferredPickupFromStorage();
      };
      this._onRootChange = (e) => {
        const t = e.target;
        if (
          t &&
          (t.name === "variant-id" ||
            (t.name === "id" && t.closest("form.f8pr")))
        )
          this.refreshFromDom();
      };
      this._onProductVariants = () => {
        window.requestAnimationFrame(() => this.refreshFromDom());
      };

      window.addEventListener("storage", this._onStorage);
      document.addEventListener(
        "store-selector:selected-location",
        this._onStoreSelected,
      );
      window.addEventListener("productVariants", this._onProductVariants);
      if (this._root) this._root.addEventListener("change", this._onRootChange);

      if (this._linkEl) {
        this._onLinkClick = (e) => {
          e.preventDefault();
          document.dispatchEvent(new Event("openStoreSelector"));
        };
        this._linkEl.addEventListener("click", this._onLinkClick);
      }

      this.refreshFromDom();
      if (
        typeof window.storeSelectorSyncPreferredPickupFromStorage === "function"
      )
        window.requestAnimationFrame(() =>
          window.storeSelectorSyncPreferredPickupFromStorage(),
        );
    }

    disconnectedCallback() {
      window.removeEventListener("storage", this._onStorage);
      document.removeEventListener(
        "store-selector:selected-location",
        this._onStoreSelected,
      );
      window.removeEventListener("productVariants", this._onProductVariants);
      if (this._root)
        this._root.removeEventListener("change", this._onRootChange);
      if (this._linkEl && this._onLinkClick)
        this._linkEl.removeEventListener("click", this._onLinkClick);
    }

    getVariantId() {
      const fid = this.dataset.formId;
      const form = fid ? document.getElementById(fid) : null;
      const input =
        form?.querySelector('input.product-variant-id[name="id"]') ||
        form?.querySelector('input[name="id"]');
      return input?.value ? String(input.value) : "";
    }

    isPickupOnly() {
      return this.dataset.pickupOnly === "true";
    }

    refreshFromDom() {
      const variantId = this.getVariantId();
      const meta = variantId ? this._variants[variantId] : null;
      const requiresShipping =
        meta && typeof meta.requiresShipping === "boolean"
          ? meta.requiresShipping
          : true;
      const pickups = Array.isArray(meta?.pickups) ? meta.pickups : [];

      const pickupOnly = this.isPickupOnly();

      if (this._shipLabelEl && this._shipDateEl) {
        this._shipDateEl.textContent = "";
        if (!requiresShipping) {
          this._shipLabelEl.textContent = this.dataset.shippingNa || "";
        } else if (pickupOnly) {
          this._shipLabelEl.textContent =
            this.dataset.notAvailableDelivery || "";
        } else {
          this._shipLabelEl.textContent = this.dataset.availableDelivery || "";
        }
      }

      const sel = readSelectedLocation();
      const selKey = sel ? locationIdKey(sel.id) : "";
      const selName = (sel && (sel.name || sel.title || "")) || "";

      const pickupTitleDefault = this.dataset.pickupHeadingDefault || "";
      const pickupTitleAvailable = this.dataset.pickupAvailableAt || "";
      const pickupTitleUnavailable = this.dataset.pickupNotAvailableAt || "";

      if (this._pickupHeadingEl) {
        if (!selKey) {
          this._pickupHeadingEl.textContent = pickupTitleDefault;
        } else {
          const row = pickups.find(
            (p) => locationIdKey(p.locationId) === selKey,
          );
          const ok = row && row.available;
          this._pickupHeadingEl.textContent = ok
            ? pickupTitleAvailable
            : pickupTitleUnavailable;
        }
      }

      if (this._pickupLineEl) {
        if (!selKey) {
          this._pickupLineEl.textContent = this.dataset.selectStore || "";
        } else {
          const displayName = storeDisplayLabel(sel) || selKey || selName;
          this._pickupLineEl.textContent = displayName;
        }
      }
    }
  }

  if (!customElements.get("product-shipping-bopis"))
    customElements.define("product-shipping-bopis", ProductShippingBopis);
})();
